import React from 'react';
import { useBizEntityCatalog } from '@saviynt/biz-entity-catalog';
import { Button, Icon, Tooltip } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../shared/utils/localization';

interface CreateClientButtonProps {
  /** When true, disables the button because roles failed to load */
  hasRolesError?: boolean;
}

/** Custom create button rendered in the BizEntityCatalog header */
export function CreateClientButton({
  hasRolesError = false,
}: CreateClientButtonProps): JSX.Element {
  const l = useInvertedLocalize();
  const { openCreateModal } = useBizEntityCatalog();
  const isDisabled = hasRolesError;

  const button = (
    <Button
      kind='outlined'
      size='medium'
      leftIcon={<Icon kind='Add' />}
      onClick={openCreateModal}
      isDisabled={isDisabled}>
      {l('Create Client')}
    </Button>
  );

  if (isDisabled) {
    return (
      <Tooltip text={l('Unable to load roles. Please try again later.')}>
        {button}
      </Tooltip>
    );
  }

  return button;
}
